import Typography from "components/typography";

import React from "react";
import styled from "styled-components";

const TrackDetails = ({
  albumCover,
  releaseType,
  releaseTitle,
  artistName
}: {
  albumCover: string;
  releaseType: string;
  releaseTitle: string;
  artistName: string;
}) => {
  return (
    <Container>
      <CoverImage src={albumCover} alt="cover-image" />
      <Typography size="s" mb="1.6" m_display="none">
        {releaseType}
      </Typography>
      <Typography size="4rem" weight="bold" mb="1.6" m_size="lg" m_mb="0.4">
        {releaseTitle}
      </Typography>
      <Typography size="2xl" weight="medium" m_size="s">
        {artistName}
      </Typography>
    </Container>
  );
};

export default TrackDetails;

const Container = styled.div`
  @media only screen and (max-width: 769px) {
    text-align: center;
    margin-bottom: 1.6rem;
  }
`;

const CoverImage = styled.img`
  width: 45rem;
  height: 45rem;
  border-radius: 1rem;
  margin-bottom: 1.6rem;
  @media only screen and (max-width: 769px) {
    width: 27rem;
    height: 27rem;
  }
`;
